import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import {
  periodColumnDefinition,
} from '../../shared/columnDefinitions';
import { exportCompanyCodeColumnDefs } from '../../shared/columnDefinitions/companyCodes';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';
import { sortBySeverity } from '../../shared/sortBySeverity';

export default ({
  periodName,
  entities,
  environmentSuffix,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
}) => {
  const CompanyCodesWithPeriods = entities.map(companyCode => ({
    periodName,
    ...companyCode,
  })).sort(sortBySeverity);

  const sheetData = [{
    name: 'Company Codes',
    type: SheetExportTypes.GRID,
    columnDefinitions: [
      periodColumnDefinition,
      ...exportCompanyCodeColumnDefs,
    ],
    data: CompanyCodesWithPeriods,
    options: {
      shouldDisplayZero,
      hideDecimals,
      negativeMinus,
    },
  }];

  xlsxExport({
    sheetData,
    metadata: {
      fileName: `TLS_Company Codes_${periodName}${environmentSuffix}`,
      disableHeaderRendering: true,
    },
  });
};
